import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=bbd3d20e&scoped=true"
var script = {}
import style0 from "./Alert.vue?vue&type=style&index=0&id=bbd3d20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd3d20e",
  null
  
)

export default component.exports